import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useReactToPrint } from 'react-to-print';

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {createPackage,getPackageData,setPackage} from '../../../Redux/actions/packageActions'

import {errorParser,camelToSentence} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'
import QRCode from "react-qr-code";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({record,not_available,loading,cartAdd}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart,locations } = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data,
      locations: state.locations.locations 
    }), shallowEqual)


    const [qty, setQty] = useState(0); 
    const [directShip, setDirectShip] = useState(false); 

 
    useEffect(() => {
  
      if(record?.direct_ship && user){
     

        if( record.direct_ship.includes(user.branch)){
          setDirectShip(true)
        }       
  
      }


    },[record,user]);

    useEffect(() => {
      console.log(cart)
  

      var exists = false
      cart.map(item=>{
        if(record.id == item.product){
          setQty(item.quantity)
          exists = true
        }
      })
      if(!exists){
        setQty(0)
      }

    },[cart]);

  
    const addthis = () =>{
      if(qty > 0){
  
        cartAdd(record,qty)
      }else{
        message.error('input quantity')
      }

    }
    var defaultChecked = false

    return(  
      <div onClick={(e)=>{e.preventDefault();e.stopPropagation()}}>
        <InputNumber 
            min={0} 
            value ={qty} 
            defaultValue={qty} 
            onChange={(e)=>{setQty(e)}}  
          />  
        <Button type='primary' disabled={not_available} loading={loading} onClick={(e)=>{e.preventDefault();e.stopPropagation();addthis()}}>Add to Cart</Button>
        {directShip? "Ships Directly" : ""}
      </div>
    )
}
  
export default Index
  